import {codeObject, datasourceTypeObject, stationObject, stnEntity} from "../../common/constructorObject";

export const coefficientsObject = {
    A: "",
    B: "",
    C: "",
    D: ""
}

export const filterPairElementObject = {
    type: {...datasourceTypeObject},
    code: {...codeObject},
    stnEntity: {...stnEntity}
}

export const filterPairRowObject = {
    rainfall: {...filterPairElementObject},
    level: {...filterPairElementObject}
}

export const floodObject = {
    name: "",
    station: {...stationObject},
    filters: [{...filterPairRowObject}],
    equation: "",
    coefficients: {...coefficientsObject},
    catchmentArea: ""
}
